import React, { useEffect } from 'react';
import { AiOutlineMenu } from 'react-icons/ai';
import { FiShoppingCart } from 'react-icons/fi';
import { BsChatLeft } from 'react-icons/bs';
import { RiNotification3Line } from 'react-icons/ri';
import { MdKeyboardArrowDown, MdLogout } from 'react-icons/md';
import { TooltipComponent } from '@syncfusion/ej2-react-popups';
import { useStateContext } from '../contexts/ContextProvider';
import avatar from '../data/avatar.jpg';
import { Cart, Chat, Notification, UserProfile } from '.';
import Dropdown from './Dropdown';
import { truncate } from '../data/utils';

const NavButton = ({ title, customFunc, icon, color, dotColor }) => {
	return (
		<TooltipComponent
			content={title}
			position='BottomCenter'
			cssClass='my-tooltip'
		>
			<button
				type='button'
				onClick={() => customFunc()}
				style={{ color }}
				className='
					relative text-xl rounded-full p-3
					hover:bg-light-gray dark:hover:bg-gray-700
					transition-all duration-200 ease-in-out
					focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-300
					dark:focus:ring-gray-600
				'
			>
				{dotColor && (
					<span
						style={{ background: dotColor }}
						className='absolute inline-flex rounded-full h-2 w-2 top-2 right-2
							animate-pulse'
					></span>
				)}
				{icon}
			</button>
		</TooltipComponent>
	);
};

const Navbar = () => {
	const {
		currentColor,
		activeMenu,
		setActiveMenu,
		handleClick,
		isClicked,
		setScreenSize,
		screenSize,
		setUser,
		currentUser,
	} = useStateContext();
	useEffect(() => {
		const handleResize = () => setScreenSize(window.innerWidth);

		window.addEventListener('resize', handleResize);

		handleResize();

		return () => window.removeEventListener('resize', handleResize);
	}, []);

	useEffect(() => {
		if (screenSize <= 900) {
			setActiveMenu(false);
		} else {
			setActiveMenu(true);
		}
	}, [screenSize]);

	const handleActiveMenu = () => setActiveMenu(!activeMenu);
	const handleLogout = () => {
		setUser('');
		localStorage.clear();
	};

	return (
		<div className='flex justify-between p-2 md:mr-6 md-ml-6 relative'>
			<NavButton
				customFunc={handleActiveMenu}
				title='Menu'
				icon={<AiOutlineMenu />}
				color={currentColor}
			/>
			<div className='flex'>
				<TooltipComponent content={'Profile'} position={'BottomCenter'}>
					<div
						className='flex item-center gap-2 cursor-pointer px-2 py-1 hover:bg-light-gray rounded-lg'
						onClick={() => handleClick('userProfile')}
					>
						<img
							className='rounded-full w-8 h-8'
							src={currentUser?.picture || avatar}
							alt='user-profile'
						/>
						<p>
							<span className='text-gray-400 text-14'>Hi,</span>
							<span className='text-gray-400 text-14 ml-1 font-bold'>
								{truncate(currentUser?.fullName, 10)}
							</span>
						</p>
					</div>
				</TooltipComponent>
				<NavButton
					title='Logout'
					customFunc={handleLogout}
					color={currentColor}
					icon={<MdLogout />}
				/>
			</div>
		</div>
	);
};

export default Navbar;
